import { STAFF_PRESENT, STAFF_ABSENT } from "@project/common"
import { Button } from "antd"
import { useTranslation } from "react-i18next"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 5px;
`

const StyledButton = styled(Button)`
  background-color: #ffffff;
  border-color: #d2d1d1;
  border-radius: 5px;
`

export const AttendanceTypeButtons = ({ onChange }) => {
  const { t } = useTranslation()
  return (
    <Wrapper className={"staff-attendance-buttons"}>
      <StyledButton
        onClick={() => {
          onChange(STAFF_PRESENT)
        }}
      >
        {t("Present")}
      </StyledButton>
      <StyledButton
        onClick={() => {
          onChange(STAFF_ABSENT)
        }}
      >
        {t("Absence ")}
      </StyledButton>
    </Wrapper>
  )
}
